import { AxiosPromise } from 'axios';

import type {
  QuestionnaireConfigurationCreateRequest,
  QuestionnaireConfigurationDTO,
  QuestionnaireConfigurationUpdateRequest,
} from '../model';

import { hosts } from '@/config';
import { BaseClient } from '@/clients/BaseClient/BaseClient';

class QuestionnaireClient extends BaseClient {
  ensureQuestionnaireConfiguration(
    data: QuestionnaireConfigurationCreateRequest,
  ): AxiosPromise<QuestionnaireConfigurationDTO> {
    return this.request({
      url: `${hosts.communicationApi()}/questionnaire/configuration/ensure`,
      method: 'POST',
      data,
    });
  }

  updateQuestionnaireConfiguration(
    data: QuestionnaireConfigurationUpdateRequest,
  ): AxiosPromise<QuestionnaireConfigurationDTO> {
    return this.request({
      url: `${hosts.communicationApi()}/questionnaire/configuration`,
      method: 'PUT',
      data,
    });
  }
}

export const questionnaireClient = new QuestionnaireClient();
